import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 设备组织
  getVideoOrganizationPage: `${baseUrl}/videoOrganization/getPage`,

  // 添加组织
  addVideoOrganization: `${baseUrl}/videoOrganization/add`,

  // 删除组织
  deleteVideoOrganizationByCodes: `${baseUrl}/videoOrganization/deleteByCodes`,

  // 修改组织
  updateVideoOrganization: `${baseUrl}/videoOrganization/update`,

  // 组织层级
  getVideoOrganizationByParentCode: `${baseUrl}/videoOrganization/getByParentCode`,

  // 添加设备
  addVideoDevice: `${baseUrl}/videoDevice/add`,

  // 修改设备
  updateVideoDevice: `${baseUrl}/videoDevice/update`,

  // 更新通道
  updateChannel: `${baseUrl}/videoDevice/updateChannel`,

  // 获取设备详情
  getVideoDeviceByCode: `${baseUrl}/videoDevice/getByCode`,

  // 获取设备分页
  getVideoDevicePage: `${baseUrl}/videoDevice/getPage`,

  // 获取设备列表
  getVideoDeviceList: `${baseUrl}/videoDevice/getDeviceList`,

  // 删除设备
  deleteVideoDeviceByCodes: `${baseUrl}/videoDevice/deleteByCodes`,

  // 预览
  preview: `${baseUrl}/videoDevice/preview`,

  // 大华视频预览
  getVideoHlsStream: `${baseUrl}/videoDevice/getVideoHlsStream`,

  // 获取通道
  getChannel: `${baseUrl}/videoDevice/getChannel`,

  // 获取通道流
  previewStream: `${baseUrl}/videoDevice/previewStream`,

  // 导出设备
  exportVideoDevice: `${baseUrl}/videoDevice/export`,

  // 获取设备厂家
  getAllDeviceManufacture: `${baseUrl85}/common/getAllDeviceManufacture`,

  // 获取设备型号
  getAllDeviceType: `${baseUrl85}/common/getAllDeviceType`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl85}/building/getBuildingList`,

  // 获取责任人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 设备状态分页
  getVideoDeviceStatusPage: `${baseUrl}/videoDeviceStatus/getPage`,

  // 导出设备状态
  exportVideoDeviceStatus: `${baseUrl}/videoDeviceStatus/export`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/VideoServices.js